export default "__VITE_ASSET__D5wxPP3y__"